import {Event} from "../../../types/eventTypes"
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {useTheme} from "../../../contexts/theme";
import {formatUTCDate} from "../../../utils/dateTimeutils";
import Divider, { dividerClasses } from '@mui/material/Divider';
import TransparentButton from "../../CommonComponents/TransparentButton/TransparentButton";
import {useNavigate} from "react-router-dom";

interface MatchDayEventProps {
    event: Event;
    onUpdateClick: () => void;
    onStartJobClick: () => void;
}

const MatchDayEvent: React.FC<MatchDayEventProps> = ({event, onUpdateClick, onStartJobClick}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const typographyStyle = {
        fontWeight: theme.fontWeights.subParagraphTitle,
        color: theme.palette.white,
        marginLeft: theme.spacing.sm,
    }

    return (
            <Box width={'100%'}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    '& svg': {
                        m: 1,
                    },
                    [`& .${dividerClasses.root}`]: {
                        mx: 0.5,
                    },
                }}
                >
                    <Box width="60%" sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        gap: theme.spacing.sm,
                        padding: `${theme.spacing.sm} ${theme.spacing.sm}`,
                    }}>
                        <Box sx={{ display: 'flex'}}>
                            <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} flex={1} sx={{paddingRight: theme.spacing.sm}}>

                                    <Typography
                                        variant="body1"
                                        sx={typographyStyle}
                                    >
                                        {event.home_team}
                                    </Typography>


                                    <Typography
                                        variant="body1"
                                        sx={typographyStyle}
                                    >
                                        {event.home_score}
                                    </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex' }}>
                            <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} flex={1} sx={{paddingRight: theme.spacing.sm}}>
                                    <Typography
                                        variant="body1"
                                        sx={typographyStyle}
                                    >
                                        {event.away_team}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={typographyStyle}
                                    >
                                        {event.away_score}
                                    </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        display={'flex'}
                        flex={1}
                        gap={theme.spacing.xs}
                        justifyContent={'space-between'}
                        flexDirection={"column"}
                        sx={{
                            padding: theme.spacing.sm,
                            borderLeft:  `${theme.border.type.solid} ${theme.border.width.thin} ${theme.palette.white}`
                        }}
                    >
                        <TransparentButton text={'Update event'} width={'100%'} onClick={onUpdateClick}/>
                        <Typography
                            variant="caption"
                            sx={{ color: theme.palette.white}}
                        >
                            {formatUTCDate(event.start_schedule, false) ? formatUTCDate(event.start_schedule, false) : 'No start available'}
                        </Typography>
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Box
                                    sx={{
                                        width: '20px',
                                        height: '20px',
                                        borderRadius: '50%',
                                        backgroundColor: (event.ready || event.scheduled) ? theme.palette.green: theme.palette.red ,
                                    }}
                                />
                                <Typography
                                    variant="caption"
                                    sx={{ color: theme.palette.white}}
                                >
                                    {event.scheduled ? 'Scheduled' : (event.ready ? 'Complete' :  'Missing Info')}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        display={'flex'}
                        flex={1}
                        justifyContent={'space-between'}
                        flexDirection={"column"}
                        sx={{
                            padding: theme.spacing.sm,
                            borderLeft:  `${theme.border.type.solid} ${theme.border.width.thin} ${theme.palette.white}`
                        }}
                    >
                        {(event.ready || event.scheduled) && <TransparentButton text={'Schedule Job'} onClick={onStartJobClick}/>}
                        <TransparentButton text={'Go to Clips'} onClick={() => navigate({pathname: '/match', search: `?eventId=${event.id}`})}/>
                    </Box>
                </Box>
            </Box>
    );
}

export default MatchDayEvent;